<template>
  <section class="cv-card" aria-labelledby="cvcard-title">
    <div class="cv-ribbon">
      <div class="cv-ribbon__text">
        本日 <strong>{{ nowLabel }}</strong><br>すぐにご案内可能！
      </div>
    </div>

    <div class="cv-arrow">▼</div>

    <div class="cv-trust">
      <div class="cv-trust__card">
        <h3 class="cv-trust__title" id="cvcard-title">{{ vendorName }}</h3>
        <div class="cv-trust__logo-wrap">
          <img class="cv-trust__logo" src="../../assets/rank-table/vendor-1.png" :alt="vendorName" />
        </div>

        <div class="cv-trust__content">
          <ul class="cv-trust__bullets">
            <li><span class="check">✔</span><span class="bold-red">最短30分で駆けつけ！</span></li>
            <li><span class="check">✔</span><span class="bold-red">最大91%OFF！</span>業界最安値級！</li>
            <li><span class="check">✔</span>Google<span class="bold-red">口コミ4.8！</span></li>
            <li><span class="check">✔</span>工事・商品の<span class="bold-red">10年無料保証</span></li>
          </ul>
        </div>
      </div>
    </div>

    <div>
      <img class="cv-hero__illust" :src="personImg" alt="" role="presentation" />
    </div>

    <div class="cv-bottom-cta">
      <a
        class="btn btn-primary pulse-btn"
        :href="affiliateLink"
        target="_blank"
        rel="nofollow noopener"
        aria-label="まずは無料相談してみる（新しいタブで開く）"
        @click="affClick"
      >
        まずは無料見積もりを依頼する
      </a>
    </div>
  </section>
</template>

<script>
import { makeAffiliateUrl } from '../../utils/aff.js';
import { affClick } from '../../utils/affClick.js'; 
export default {
  name: "CVBoostCard",
  props: {
    vendorName: { type: String, default: "給湯器駆けつけ隊" },
    vendorLogo: { type: String, required: true },
    personImg: { type: String, required: true },
    now: { type: Date, default: () => new Date() },
  },
  data() {
    return { nowInternal: this.now, timerId: null };
  },
  computed: {
    nowLabel() {
      const d = this.nowInternal;
      const m = d.getMonth() + 1;
      const day = d.getDate();
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      return `${m}月${day}日${hh}時${mm}分`;
    },
    methods: {
        affClick
    },
    affiliateLink() {
      return makeAffiliateUrl();
    }
  },
  mounted() {
    this.timerId = setInterval(() => { this.nowInternal = new Date(); }, 1000);
  },
  beforeUnmount() {
    if (this.timerId) clearInterval(this.timerId);
  },
};
</script>

<style scoped>
.cv-card {
  background: #f9f6da;
  max-width: 920px;
  margin-top: 30px;
}

.cv-ribbon {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #d9534f;
  padding: 20px 16px;
  font-size: 1.4rem;
  font-weight: bold;
  color: #fff;
  line-height: 1.4;
}
.cv-ribbon__text strong {
  font-size: 1.6rem;
  color: #f3d67f;
  font-weight: 900;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.cv-arrow {
  text-align: center;
  font-size: 3.4rem;
  color: #d9534f;
  font-weight: bold;
  animation: bounce 1.2s infinite;
  margin-top: -20px;
  margin-bottom: 10px;
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(6px); }
}

.cv-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #fff9f1;
  border: 1px dashed #ffd9a6;
  border-radius: 12px;
  padding: 14px;
  margin-top: 12px;
}
.cv-hero__illust {
  width: 80%;
  margin-top: 20px;
}

.cv-trust { padding: 10px; padding-top: 0; }
.cv-trust__card {
  background: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-evenly;
  border: 1px solid rgb(211, 208, 208);
}
.cv-trust__logo-wrap { flex: 0 0 35%; text-align: center; }
.cv-trust__logo { width: 80%; height: auto; margin-bottom: 6px; }
.cv-trust__content { flex: 1; display: flex; flex-direction: column; align-items: center; }
.cv-trust__bullets {
  list-style: none; margin: 0; padding: 0;
  display: grid; gap: 8px; font-weight: 600; color: #2b3a4a; line-height: 1.5;
}
.cv-trust__bullets li { display: flex; gap: 6px; align-items: flex-start; }

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 12px 18px;
  border-radius: 4px;
  font-weight: 700;
}

.btn-primary{
  --btn-bg:#ff7a00;       
  --btn-bg-dark:#e96e00;  
  --btn-grad-top:#ffa043; 
  --btn-shadow:0 10px 24px rgba(233,110,0,.28);
  --btn-radius:999px;

  color:#fff;
  background: linear-gradient(180deg, var(--btn-grad-top) 0%, var(--btn-bg) 40%, var(--btn-bg) 100%);
  border:2px solid var(--btn-bg-dark);
  border-radius: var(--btn-radius);
  box-shadow: var(--btn-shadow);
  width: 100%;
  max-width: 640px;
  box-sizing: border-box;
  padding: 18px 24px;
  font-size: clamp(16px, 2.6vw, 20px);
  letter-spacing: .02em;
  line-height: 1.1;

  position: relative;
  isolation: isolate;
  overflow: hidden;

  transition: transform .08s ease, box-shadow .2s ease, filter .2s ease;
}

.btn-primary::after{
  content: "▶";
  font-size: 1em;
  translate: 0 1px;
  margin-left: .5em;
}

/* シャイン演出（pulseと共存） */
.btn-primary::before{
  content:"";
  position:absolute;
  top:0; left:-80px;
  width:60px; height:100%;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.55) 50%, rgba(255,255,255,0) 100%);
  transform: skewX(-20deg);
  animation: shine 4s infinite;
  pointer-events:none;
}
@keyframes shine{
  0%{ left:-80px; }
  60%{ left:115%; }
  100%{ left:115%; }
}

.btn-primary:hover{
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(233,110,0,.32);
  filter: brightness(1.02);
}
.btn-primary:active{
  transform: translateY(0);
  box-shadow: 0 8px 16px rgba(233,110,0,.22);
}
.btn-primary:focus-visible{
  outline: none;
  box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba(255,122,0,.9), var(--btn-shadow);
}

.cv-bottom-cta { text-align: center; padding-bottom: 30px; }
.cv-bottom-cta .btn {
  width: 80%;
  max-width: 640px;
  padding: 18px 24px;
  font-size: clamp(16px, 2.6vw, 20px);
  box-sizing: border-box;
  font-weight: 800;
}

.pulse-btn { animation: pulse 1.6s infinite ease-in-out; }
@keyframes pulse { 0%{ transform: scale(1); } 50%{ transform: scale(1.05); } 100%{ transform: scale(1); } }

@media (min-width: 481px) {
  .cv-trust__card {
    display: grid;
    grid-template-columns: 260px 1fr;
    grid-template-rows: auto auto;
    column-gap: 20px; row-gap: 6px;
    align-items: start; justify-content: initial;
  }
  .cv-trust__logo-wrap { grid-column: 1; grid-row: 1 / span 2; justify-self: center; align-self: start; }
  .cv-trust__logo { width: 85%; height: auto; margin: 0; }
  .cv-trust__title { grid-column: 2; grid-row: 1; margin: 35px 0 0; font-size: 1.6rem; line-height: 1.22; text-align: left; }
  .cv-trust__content { grid-column: 2; grid-row: 2; align-items: flex-start; margin-top: 0; }
  .cv-trust__bullets { margin: 0; width: 100%; gap: 6px; }
  .cv-trust__bullets li { align-items: center; }
}

@media (max-width: 480px) {
  .cv-hero { flex-direction: column; text-align: center; }
  .cv-trust__card { flex-direction: column; text-align: center; border: 1px solid gray; border-radius: 10px; padding: 10px; }
  .cv-hero__illust { width: 90%; }
  .cv-trust__content { align-items: center; }
  .cv-bottom-cta .btn { width: 92%; max-width: none; }
  h3 { font-size: 1.5rem; margin: 0 0 10px; }
}

@media (prefers-color-scheme: dark){
  .btn-primary{ filter: saturate(1.05) brightness(1.05); }
}
</style>
